module.exports = __webpack_public_path__ + "assets/images/private-courses.1c073373.png";


//////////////////
// WEBPACK FOOTER
// ./imgs/private-courses.png
// module id = 180
// module chunks = 0